import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import formMessage from 'src/examples/Message/default';
import systemMessage from 'src/examples/Message/system';
import variantFormMessage from 'src/examples/Message/variantForm';
import variantSystemMessage from 'src/examples/Message/variantSystem';
import layoutMessage from 'src/examples/Message/layout';
import layout2Message from 'src/examples/Message/layout-2';
import layout3Message from 'src/examples/Message/layout-3';
import layout4Message from 'src/examples/Message/layout-4';
import layout5Message from 'src/examples/Message/layout-5';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  formMessage,
  systemMessage,
  variantFormMessage,
  variantSystemMessage,
  layoutMessage,
  layout2Message,
  layout3Message,
  layout4Message,
  layout5Message,
  React
};